import { useContext, useEffect, useState } from "react";
import {
  BlockAddress,
  Campaigns,
  ContentTableMobile,
  LeaderboardBottom,
  LeaderboardContainer,
  LeaderboardTop,
  LeaderboardTotal,
  LeaderboardWrapper,
} from "./styled";
import { SwapBenifitTag, SwapTop } from "../Swap/styled";
import TitleCommon from "../../../components/Common/Title";
import { ContextProviderWrapper } from "../../../components/Context";
import TableCommon from "../../../components/Common/TableCommon";
import { shortenAddress } from "../../../utils/addressUser";
import CopyToClipboard from "react-copy-to-clipboard";
import { CopyOutlined } from "@ant-design/icons";
import toast from "react-hot-toast";
import { convertFixed } from "../../../utils/convertNumber";
import moment from "moment";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import { AVAX_API } from "../../../services/api/indexV2";

export interface LeaderboardUser {
  id: string;
  createdAt: string;
  updatedAt: string;
  version: number;
  email: string | null;
  address: string;
  name: string;
  lastLogin: string;
  isWhitelist: boolean;
  roles: string[];
  claimIndex: number;
  isLocked: boolean;
  referralCode: string;
  parentId: string;
  inviteCount: number;
  isJoined: boolean;
  avatar: string | null;
  bio: string | null;
}

export interface LeaderboardEntry {
  id: string;
  createdAt: string;
  updatedAt: string;
  version: number;
  user_id: string;
  point: number;
  seasion_id: string;
  user: LeaderboardUser;
}

const Leaderboard = () => {
  const { theme, isMobile } = useContext(ContextProviderWrapper)!;
  const [statistic, setStatistic] = useState<any>({});
  const [dataLeaderboard, setDataLeaderboard] = useState<LeaderboardEntry[]>(
    []
  );

  const leaderboardData = [
    {
      address: "0x33736e1c20ff2b6ecb8d7dfc4ce87a62",
      totalPoints: 11.264191,
      totalPointsFormatted: "11.26",
      referrals: 0,
      totalVolume: 4.327748,
      rewards: 1.126419,
      inviteCount: 3,
      referralCode: "REF912743",
      time: "2025-07-02T11:12:06.593099",
    },
    {
      address: "0x92b505a92a9870e3dcb0c332ce53da63",
      totalPoints: 117.556872,
      totalPointsFormatted: "117.56",
      referrals: 3,
      totalVolume: 6.911048,
      rewards: 11.755687,
      inviteCount: 3,
      referralCode: "REF696518",
      time: "2025-07-01T11:12:06.593099",
    },
    {
      address: "0x6d4edc7d6f307723826ec6c64dd615b2",
      totalPoints: 2.432221,
      totalPointsFormatted: "2.43",
      referrals: 2,
      totalVolume: 23.3339,
      rewards: 0.243222,
      inviteCount: 5,
      referralCode: "REF751315",
      time: "2025-06-30T11:12:06.593099",
    },
    {
      address: "0xdb48bab78142416e7411f91d1ea3f353",
      totalPoints: 193.453755,
      totalPointsFormatted: "193.45",
      referrals: 1,
      totalVolume: 44.91738,
      rewards: 19.345376,
      inviteCount: 0,
      referralCode: "REF411900",
      time: "2025-06-29T11:12:06.593099",
    },
    {
      address: "0x59a793c18481a065c4a6da971a85daba",
      totalPoints: 102.009704,
      totalPointsFormatted: "102.01",
      referrals: 4,
      totalVolume: 1.109634,
      rewards: 10.20097,
      inviteCount: 3,
      referralCode: "REF782062",
      time: "2025-06-28T11:12:06.593099",
    },
    {
      address: "0x00a2e2344217818618fa29c6cb03057c",
      totalPoints: 76.704822,
      totalPointsFormatted: "76.70",
      referrals: 5,
      totalVolume: 20.905705,
      rewards: 7.670482,
      inviteCount: 5,
      referralCode: "REF891431",
      time: "2025-06-27T11:12:06.593099",
    },
    {
      address: "0xa5e37434cbffe5839ea7f7495535b17b",
      totalPoints: 85.795622,
      totalPointsFormatted: "85.80",
      referrals: 2,
      totalVolume: 46.076597,
      rewards: 8.579562,
      inviteCount: 4,
      referralCode: "REF855102",
      time: "2025-06-26T11:12:06.593099",
    },
    {
      address: "0x7b8d6984334f7d9e2a78094400c0ab7a",
      totalPoints: 118.675715,
      totalPointsFormatted: "118.68",
      referrals: 2,
      totalVolume: 1.146442,
      rewards: 11.867572,
      inviteCount: 0,
      referralCode: "REF243278",
      time: "2025-06-25T11:12:06.593099",
    },
    {
      address: "0xddff545576f2e70ddd57210973b57ba4",
      totalPoints: 0.844538,
      totalPointsFormatted: "0.84",
      referrals: 3,
      totalVolume: 17.282212,
      rewards: 0.084454,
      inviteCount: 5,
      referralCode: "REF496495",
      time: "2025-06-24T11:12:06.593099",
    },
    {
      address: "0x2eea227e96c3ecab93bfd4fdc46195c1",
      totalPoints: 30.374887,
      totalPointsFormatted: "30.37",
      referrals: 0,
      totalVolume: 46.144586,
      rewards: 3.037489,
      inviteCount: 4,
      referralCode: "REF669540",
      time: "2025-06-23T11:12:06.593099",
    },
  ];

  const sortedLeaderboard = leaderboardData.sort(
  (a, b) => b.totalPoints - a.totalPoints
);

  const listTotal = [
    {
      text: "Total Wallet",
      // number: statistic?.totalWallet ? statistic?.totalWallet : 0,
      number: 10,
    },
    {
      text: "Total Volume",
      number: `$${convertFixed(statistic?.totalVolume)}`,
    },
    {
      text: "Total Transaction",
      // number: statistic?.totalTransaction ? statistic?.totalTransaction : 0,
      number: 85,
    },
  ];

  const benifitTags = [
    {
      title: "Top rank",
      color: theme === "light" ? "#0FF586" : "#0FF586",
    },
    {
      title: "More reward",
      color: theme === "light" ? "#F0CC54" : "#F0CC54",
    },
  ];

  const headingData = !isMobile
    ? [
        // {
        //   name: `Time`,
        //   dataIndex: "",
        //   key: "",
        //   render: (data: any) => {
        //     return (
        //       <p>
        //         {data ? moment(data.createdAt).format("MMMM DD - HH:mm") : "--"}
        //       </p>
        //     );
        //   },
        // },
        // {
        //   name: `Rank`,
        //   dataIndex: "index",
        //   key: "index",
        //   render: (data: any) => {
        //     return <p>{data}</p>;
        //   },
        // },
        {
          name: `Wallet Address`,
          dataIndex: "",
          key: "",
          render: (data: any) => {
            return (
              <BlockAddress>
                <CopyToClipboard
                  text={`${data?.address ? data?.address : "--"}`}
                  onCopy={() => {
                    toast.success("Copied !!");
                  }}
                >
                  <div className={`copy-inner ${theme}`}>
                    <p>
                      {data?.address ? shortenAddress(data?.address) : "--"}
                    </p>
                    <CopyOutlined />
                  </div>
                </CopyToClipboard>
              </BlockAddress>
            );
          },
        },
        {
          name: `Total Points`,
          dataIndex: "",
          key: "",
          render: (data: any) => {
            return <p>{data ? data.totalPoints : 0}</p>;
          },
        },
        {
          name: `Referrals`,
          dataIndex: "",
          key: "",
          render: (data: any) => {
            return (
              // <p>{data?.user.referralCode ? data?.user.referralCode : "--"}</p>
              <p>{data?.referralCode ? data?.referralCode : "--"}</p>
            );
          },
        },
        {
          name: `Total Volume`,
          dataIndex: "",
          key: "",
          render: (data: any) => {
            return (
              <p>
                {data?.totalVolume
                  ? `$${convertFixed(data?.totalVolume)}`
                  : "--"}
              </p>
            );
          },
        },
        {
          name: `Rewards`,
          dataIndex: "",
          key: "",
          render: (data: any) => {
            return <p>0</p>;
          },
        },
        {
          name: `Invite Count`,
          dataIndex: "",
          key: "",
          render: (data: any) => {
            return <p>{data ? data.inviteCount : 0}</p>;
          },
        },
      ]
    : [
        {
          name: `Leaderboard`,
          dataIndex: "",
          key: "",
          render: (data: any) => {
            return (
              <ContentTableMobile className={theme}>
                <div className="rank">
                  <img
                    src={
                      data.user?.avatar
                        ? data.user?.avatar
                        : "/assets/images/profile/profile_img_01.png"
                    }
                    width={60}
                    height={60}
                    loading="lazy"
                    alt="Avatar"
                  />
                </div>
                <div className="content-right">
                  <div className="block-address">
                    <p className="address">
                      {shortenAddress(data.user?.address)}
                    </p>
                  </div>
                  <div className="block-transactions">
                    <div className="transaction-inner">
                      <p>
                        Seasion
                        <span>{data.seasion_id ? data.seasion_id : "--"}</span>
                      </p>
                    </div>
                    <div className="transaction-inner">
                      <p>
                        Referral
                        <span>
                          {data.user.referralCode
                            ? data.user.referralCode
                            : "--"}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div className="block-transactions">
                    <div className="transaction-inner">
                      <p>
                        Total Volume
                        <span>
                          {data.totalVolume
                            ? `$${convertFixed(data.totalVolume)}`
                            : "--"}
                        </span>
                      </p>
                    </div>
                    <div className="transaction-inner">
                      <p>
                        Point<span>{data ? data.point.toFixed(4) : 0}</span>
                      </p>
                    </div>
                  </div>
                  <div className="block-transactions">
                    <div className="transaction-inner">
                      <p>
                        Rewards
                        <span>0</span>
                      </p>
                    </div>
                    <div className="transaction-inner">
                      <p>
                        Invite Count
                        <span>
                          {data.user.inviteCount ? data.user.inviteCount : 0}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ContentTableMobile>
            );
          },
        },
      ];
  const moveToDetail = "leaderboard";

  //get data leaderboard
  useEffect(() => {
    const fetchLeaderboard = async () => {
      const params = "S1";
      const res = await AVAX_API.getLeaderboard(params);

      const leaderboardWithIndex = res?.data?.map(
        (item: LeaderboardEntry, idx: number) => ({
          ...item,
          index: idx + 1,
        })
      );

      setDataLeaderboard(leaderboardWithIndex);
    };

    fetchLeaderboard();
  }, []);

  const handleStatisticLeaderboard = async () => {
    try {
      const res = await AVAX_API.statisticLeaderboard();
      if (res) {
        setStatistic(res?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleStatisticLeaderboard();
  }, []);

  return (
    <>
      <LeaderboardContainer>
        <LeaderboardWrapper>
          {/* <Campaigns className={theme}>
            <h2 className="title-campaign">Campaigns</h2>
            <div className="block-campaign">
              <Swiper
                slidesPerView={isMobile ? 1 : 2}
                spaceBetween={30}
                pagination={{
                  clickable: true,
                }}
                navigation={true}
                modules={[Pagination, Navigation]}
                className={theme}
              >
                {listCampaign.map((items, index) => (
                  <SwiperSlide>
                    <div className="item-campaign" key={index}>
                      <img
                        src={items.imageBanner}
                        width={501}
                        height={225}
                        loading="lazy"
                        alt="Campaign"
                        className="image-camp"
                      />
                      <div className="block-title-campaign">
                        <h3 dangerouslySetInnerHTML={{ __html: items.title }} />
                        <p className="price">{items.price}</p>
                      </div>
                      <div className="block-des">
                        <p>{items.des}</p>
                        <ul className={`list-social ${theme}`}>
                          {items.listSocial.map((item, index) => (
                            <li key={index}>
                              <Link to={item.link} className="trans">
                                <img
                                  src={theme ? item.iconLight : item.icon}
                                  width={10}
                                  height={10}
                                  loading="lazy"
                                  alt="Social"
                                />
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className="block-join">
                        <div className="join-left">
                          <img
                            src={items.imageUser}
                            width={24}
                            height={24}
                            loading="lazy"
                            alt={items.nameUser}
                            className="image-user"
                          />
                          <div className="user-info">
                            <span className="host">{items.nameHosted}</span>
                            <span className="name-user">{items.nameUser}</span>
                          </div>
                        </div>
                        <div className="join-right">
                          <ul className="list-user">
                            {items.listImageUser.map((item, index) => (
                              <li key={index}>
                                <img
                                  src={item}
                                  width={24}
                                  height={24}
                                  loading="lazy"
                                  alt="user"
                                />
                              </li>
                            ))}
                          </ul>
                          <div className="total-people">
                            <span className="number">{items.totalUser}</span>
                            <span className="part">{items.text}</span>
                          </div>
                        </div>
                      </div>
                      <div className={`block-button ${theme}`}>
                        <ButtonCommon as={Link} to="/campaign">
                          View Profile
                        </ButtonCommon>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </Campaigns> */}
          <LeaderboardTop>
            <SwapTop>
              <TitleCommon text={"kibble leaderboard"} />
              <SwapBenifitTag className={theme}>
                {benifitTags.map((item, index) => {
                  return (
                    <div
                      style={{
                        color: item.color,
                      }}
                      className="item-tag"
                      key={index}
                    >
                      <span
                        style={{
                          background: item.color,
                        }}
                      ></span>
                      {item.title}
                    </div>
                  );
                })}
              </SwapBenifitTag>
            </SwapTop>
            <LeaderboardTotal className={theme}>
              {listTotal.map((item, index) => (
                <li key={index}>
                  <p className="text">{item.text}</p>
                  <p className="number">{item.number}</p>
                </li>
              ))}
            </LeaderboardTotal>
          </LeaderboardTop>
          <LeaderboardBottom>
            <TableCommon
              data={sortedLeaderboard}
              heading={headingData}
              moveTo={moveToDetail}
              // pagination={
              //   dataLeaderboard && dataLeaderboard?.length > 10 ? true : false
              // }
            />
          </LeaderboardBottom>
        </LeaderboardWrapper>
      </LeaderboardContainer>
    </>
  );
};

const listCampaign = [
  {
    imageBanner: "/assets/images/leaderboard/leaderboard_img_01.png",
    title: "Get Start<br/>ssddfffoijdisjisdfiudfdfuydfudifdif",
    price: "$10000",
    des: "Short Discription for Campain",
    listSocial: [
      {
        icon: "/assets/images/leaderboard/icn_social_01.svg",
        iconLight: "/assets/images/leaderboard/icn_social_01_light.svg",
        link: "#",
      },
      {
        icon: "/assets/images/leaderboard/icn_social_02.svg",
        iconLight: "/assets/images/leaderboard/icn_social_02_light.svg",
        link: "#",
      },
      {
        icon: "/assets/images/leaderboard/icn_social_03.svg",
        iconLight: "/assets/images/leaderboard/icn_social_03_light.svg",
        link: "#",
      },
    ],
    imageUser: "/assets/images/leaderboard/leaderboard_img_02.png",
    nameHosted: "Hosted by",
    nameUser: "MR.Avocado",
    listImageUser: [
      "/assets/images/leaderboard/leaderboard_img_03.png",
      "/assets/images/leaderboard/leaderboard_img_04.png",
    ],
    totalUser: "19k",
    text: "Participants",
  },
  {
    imageBanner: "/assets/images/leaderboard/leaderboard_img_01.png",
    title: "Get Start<br/>ssddfffoijdisjisdfiudfdfuydfudifdif",
    price: "$10000",
    des: "Short Discription for Campain",
    listSocial: [
      {
        icon: "/assets/images/leaderboard/icn_social_01.svg",
        iconLight: "/assets/images/leaderboard/icn_social_01_light.svg",
        link: "#",
      },
      {
        icon: "/assets/images/leaderboard/icn_social_02.svg",
        iconLight: "/assets/images/leaderboard/icn_social_02_light.svg",
        link: "#",
      },
      {
        icon: "/assets/images/leaderboard/icn_social_03.svg",
        iconLight: "/assets/images/leaderboard/icn_social_03_light.svg",
        link: "#",
      },
    ],
    imageUser: "/assets/images/leaderboard/leaderboard_img_02.png",
    nameHosted: "Hosted by",
    nameUser: "MR.Avocado",
    listImageUser: [
      "/assets/images/leaderboard/leaderboard_img_03.png",
      "/assets/images/leaderboard/leaderboard_img_04.png",
    ],
    totalUser: "19k",
    text: "Participants",
  },
  {
    imageBanner: "/assets/images/leaderboard/leaderboard_img_01.png",
    title: "Get Start<br/>ssddfffoijdisjisdfiudfdfuydfudifdif",
    price: "$10000",
    des: "Short Discription for Campain",
    listSocial: [
      {
        icon: "/assets/images/leaderboard/icn_social_01.svg",
        iconLight: "/assets/images/leaderboard/icn_social_01_light.svg",
        link: "#",
      },
      {
        icon: "/assets/images/leaderboard/icn_social_02.svg",
        iconLight: "/assets/images/leaderboard/icn_social_02_light.svg",
        link: "#",
      },
      {
        icon: "/assets/images/leaderboard/icn_social_03.svg",
        iconLight: "/assets/images/leaderboard/icn_social_03_light.svg",
        link: "#",
      },
    ],
    imageUser: "/assets/images/leaderboard/leaderboard_img_02.png",
    nameHosted: "Hosted by",
    nameUser: "MR.Avocado",
    listImageUser: [
      "/assets/images/leaderboard/leaderboard_img_03.png",
      "/assets/images/leaderboard/leaderboard_img_04.png",
    ],
    totalUser: "19k",
    text: "Participants",
  },
  {
    imageBanner: "/assets/images/leaderboard/leaderboard_img_01.png",
    title: "Get Start<br/>ssddfffoijdisjisdfiudfdfuydfudifdif",
    price: "$10000",
    des: "Short Discription for Campain",
    listSocial: [
      {
        icon: "/assets/images/leaderboard/icn_social_01.svg",
        iconLight: "/assets/images/leaderboard/icn_social_01_light.svg",
        link: "#",
      },
      {
        icon: "/assets/images/leaderboard/icn_social_02.svg",
        iconLight: "/assets/images/leaderboard/icn_social_02_light.svg",
        link: "#",
      },
      {
        icon: "/assets/images/leaderboard/icn_social_03.svg",
        iconLight: "/assets/images/leaderboard/icn_social_03_light.svg",
        link: "#",
      },
    ],
    imageUser: "/assets/images/leaderboard/leaderboard_img_02.png",
    nameHosted: "Hosted by",
    nameUser: "MR.Avocado",
    listImageUser: [
      "/assets/images/leaderboard/leaderboard_img_03.png",
      "/assets/images/leaderboard/leaderboard_img_04.png",
    ],
    totalUser: "19k",
    text: "Participants",
  },
];

export default Leaderboard;
